import { useMutation, useQueryClient } from 'react-query';
import { queryKeys } from './queryKeys';
import { authFetch } from '../../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../../CommonUtils/httpBodyOptions';
import { ModelGroupsDTO } from './useModelGroupsQuery';

interface DeleteModelGroupParams {
  groupId: string;
  groupName: string;
}

const deleteModelGroup = (params: DeleteModelGroupParams) => {
  return authFetch('/Adviser/ModelPortfoliosGroups/DeleteGroup', {
    method: 'POST',
    ...httpBodyOptions(params, true),
  });
};

export const useDeleteModelGroupMutation = () => {
  const queryClient = useQueryClient();

  const modelGroupsQK = queryKeys.modelGroups();

  return useMutation<
    null,
    Error,
    DeleteModelGroupParams,
    { previousModelGroups: ModelGroupsDTO | undefined }
  >(deleteModelGroup, {
    onMutate({ groupId }) {
      const previousModelGroups = queryClient.getQueryData<ModelGroupsDTO>(modelGroupsQK);

      queryClient.setQueryData<ModelGroupsDTO | undefined>(modelGroupsQK, old => {
        if (old && old.modelPortfoliosGroups) {
          return {
            ...old,
            modelPortfoliosGroups: old.modelPortfoliosGroups.filter(
              group => group.groupId !== groupId,
            ),
          };
        }

        return old;
      });

      return { previousModelGroups };
    },

    onError: (_, __, context) => {
      if (context && context.previousModelGroups) {
        queryClient.setQueryData(modelGroupsQK, context.previousModelGroups);
      }
    },

    onSettled() {
      queryClient.invalidateQueries(modelGroupsQK);
    },
  });
};
